<template>
  <div>
    <MovieBlockedContainer
      v-if="content.component === 'movie'"
      :data="data"
      :content="content"
      :model="model"
      :imgStyle="imgStyle"
      :getImageBackgroundUrl="getImageBackgroundUrl"
      :cssVars="cssVars"
      :link="link"
    />
    <PictureBlockedContainer
      v-else-if="content.component === 'picture'"
      :data="data"
      :content="content"
      :model="model"
      :imgStyle="imgStyle"
      :getImageBackgroundUrl="getImageBackgroundUrl"
      :cssVars="cssVars"
      :link="link"
    />
    <div v-else>
      {{$t('video_watch.not_available')}}
    </div>
  </div>

</template>
<script>
import MovieBlockedContainer from "./Movie/BlockedContainer.vue"
import PictureBlockedContainer from "./Picture/BlockedContainer.vue"

export default {
  name: 'PostBlockedContainer',
  components: {MovieBlockedContainer, PictureBlockedContainer},
  props: {
    data: {},
    content: {},
    model: {}
  },
  computed: {
    imgStyle(){
      let image = this.content.public_thumbnail_image_path['small'];
      return {
        backgroundImage: `url('${image}')`
      };
    },
    getImageBackgroundUrl(){
      const fc = this.data.front_container;

      return (fc === 'normal' || fc === 'tokens')
        ? this.content.public_thumbnail_image_path['small']
        : `/img/posts/${fc}.png`;
    },
    cssVars() {
      return {
        '--background': `url('${this.getImageBackgroundUrl}')`,
      }
    },
    link() {
      const fc = this.data.front_container;

      if (fc === 'free')    return {name: 'signup.user'}
      if (fc === 'premium') return {name: 'purchase.subscription', query: {webstar: this.model.username}}
      if (fc === 'normal')  return {name: 'purchase.subscription', query: {webstar: this.model.username}}
    },
  }
}
</script>